import { useRef, useEffect, useState } from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { styled } from '@mui/material/styles';
import { Theme } from '@mui/material/styles';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(
  ({ theme }: { theme: Theme }) => ({
    position: 'relative',
    borderRadius: '20px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    border: `1px solid ${theme.palette.divider}`,
    height: '38px',
    '& .MuiToggleButton-root': {
      borderRadius: '20px !important',
      borderColor: theme.palette.divider,
      position: 'relative',
      zIndex: 1,
      border: 'none'
    },
  })
);

const StyledToggleButton = styled(ToggleButton)(
  ({ theme }: { theme: Theme }) => ({
    textTransform: 'none',
    color: '#000',
    height: '38px',
    fontWeight: 600,
    // fontFamily: 'Open Sans',
    padding: '0 16px',
    fontSize: '14px',
    zIndex: 1,
    lineHeight: '1.15',
    borderRadius: '20px',
    '&.Mui-selected': {
      color: '#fff !important',
    },
    '&:focus-visible': {
      outline: '2px solid black',
      outlineOffset: '-4px'
    }

  })
);

const ToggleComponent = ({ onHandle, statusType, data }) => {
  const [selectedValue, setSelectedValue] = useState(statusType);
  const [indicatorWidth, setIndicatorWidth] = useState(0);
  const [indicatorOffset, setIndicatorOffset] = useState(0);
  const buttonRefs = useRef<any>([]);

  const handleToggle = (event, newSelection) => {
    if (newSelection !== null) {
      setSelectedValue(newSelection);
      onHandle(newSelection);
    }
  };

  useEffect(() => {
    setSelectedValue(statusType);
  }, [statusType]);

  useEffect(() => {
    if (data && data.toggle) {
      const selectedIndex = data.toggle.indexOf(selectedValue);
      if (buttonRefs.current[selectedIndex]) {
        const selectedButton = buttonRefs.current[selectedIndex];
        setIndicatorWidth(selectedButton.offsetWidth);
        setIndicatorOffset(selectedButton.offsetLeft);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValue, data.toggle]);

  if (!data || !data.toggle) return null;

  return (
    <fieldset aria-labelledby="toggle-group-legend" style={{ border: 'none', padding: 0, margin: 0, }}>
      <legend id="toggle-group-legend" style={{ color: 'transparent', height: 0, padding: 0, margin: 0, }}>{data.filterTopic}</legend>
      <StyledToggleButtonGroup
        value={selectedValue}
        exclusive
        onChange={handleToggle}
        aria-label={data.ariaLabelSelect}
      >
        {data.toggle.map((toggleOption, index) => (
          <StyledToggleButton
            key={toggleOption}
            value={toggleOption}
            aria-label={toggleOption}
            disableFocusRipple
            disableRipple
            disableTouchRipple
            ref={(el) => (buttonRefs.current[index] = el)}
          >
            {toggleOption}
          </StyledToggleButton>
        ))}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: `${indicatorOffset}px`,
            width: `${indicatorWidth}px`,
            height: '100%',
            borderRadius: '20px',
            backgroundColor: '#1460AA',
            transition: 'left 0.2s ease, width 0.2s ease',
            zIndex: 0,
          }}
        />
      </StyledToggleButtonGroup>
    </fieldset>
  );
};

export default ToggleComponent;
